import { css } from '@emotion/react'
import { Button } from '@mui/material'
import { useApprovalContext } from '../contexts'
import { t } from '@lingui/core/macro'

const buttonPosition = css`
  top: 1px;
`

export const ResetFiltersButton = () => {
  const { isLoading, handleResetFilters } = useApprovalContext() ?? {
    isLoading: false,
    handleResetFilters: () => void {},
  }

  return (
    <Button
      onClick={handleResetFilters}
      css={buttonPosition}
      disabled={isLoading}
      color="primary"
      variant="contained"
      size="small"
    >
      {t`Reset filters`}
    </Button>
  )
}
